import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefreshCw01 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 10C0 4.47715 4.47715 0 10 0C12.7624 0 15.2648 1.12139 17.0735 2.93138C17.7132 3.57146 18.3981 4.36248 19 5.09444V2C19 1.44772 19.4477 1 20 1C20.5523 1 21 1.44772 21 2V8C21 8.55228 20.5523 9 20 9H14C13.4477 9 13 8.55228 13 8C13 7.44772 13.4477 7 14 7H17.9692C17.277 6.13128 16.4165 5.10335 15.6588 4.34511C14.2098 2.89514 12.2104 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C13.6457 18 16.7243 15.5605 17.6874 12.2227C17.8406 11.6921 18.3948 11.3861 18.9255 11.5392C19.4561 11.6923 19.7622 12.2466 19.609 12.7773C18.4055 16.9481 14.5605 20 10 20C4.47715 20 0 15.5228 0 10Z",
		fill: "currentColor"
	})
});
export default SvgRefreshCw01;
